import './top-bar.js';
import './header-hero.js';
import './info-boxes.js';
import './form-wrapper.js';

// form submit button is disabled until all required fields are filled
const submitElement = document.querySelector('.wpcf7-form input[type="submit"]');
const formInputs = document.querySelectorAll('.wpcf7-form-control:not([type="submit"])');
if (submitElement && formInputs) {
  submitElement.disabled = true;
  formInputs.forEach(input => {
    input.required = true;
    input.addEventListener('input', () => {
      let isFormValid = true;
      formInputs.forEach(input => {
        if (!input.checkValidity()) {
          isFormValid = false;
        }
      });
      submitElement.disabled = !isFormValid;
    });
  });
}
